import ChatSection from '../components/ChatSection';

const Chat = () => {
  return (
    <div className="flex flex-col flex-1 min-h-0 h-full">
      <ChatSection />
    </div>
  );
};

export default Chat;
